import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import SetStoryboard from './SetStoryboard';
import Storyboards from './Storyboards';
import styles from './ProviderStoryboards.module.scss';
import { getDefaultStoryboard } from '../../common/providers';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

export default class ProviderStoryboards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModifyingStoryboard: false,
    };

    this.onOpenStoryboardModal = this.onOpenStoryboardModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickStoryboard = this.onClickStoryboard.bind(this);
    this.onAddStoryboard = this.onAddStoryboard.bind(this);
    this.onSaveStoryboard = this.onSaveStoryboard.bind(this);

    this.onDeleteStoryboard = this.onDeleteStoryboard.bind(this);
  }

  onOpenStoryboardModal() {
    this.setState({ isModifyingStoryboard: true });
  }

  onCloseModal = () => {
    this.setState({
      isModifyingStoryboard: false,
    });
  };

  onClickStoryboard(storyboard) {
    this.props.onSelectStoryboardFunc(storyboard);
    this.onOpenStoryboardModal();
  }

  onSaveStoryboard(newstoryboard) {
    this.props.onSaveStoryboardFunc(newstoryboard);
  }

  onDeleteStoryboard(deleteIndex) {
    const { storyboards } = cloneDeep(this.props);
    if (isEmpty(storyboards)) return null;

    storyboards.splice(deleteIndex, 1);
    this.props.onSaveStoryboardFunc(storyboards);
    this.onCloseModal();
  }

  onAddStoryboard() {
    this.props.onSelectStoryboardFunc(getDefaultStoryboard());
    this.onOpenStoryboardModal();
  }

  render() {
    const storyboards = this.props.storyboards || [];

    return (
      <div className={styles.root}>
        <div
          style={{
            marginTop: '10px',
          }}
        >
          <div className={styles.title}>
              Storyboards
          </div>
          <div className={styles.description}>
              Tailor the provider narrative based on the experience       
          </div>
          <div style={{display: "flex",justifyContent: "end",marginRight: "18px"}}>
          <Button
            variant="contained"
            style={{backgroundColor:'#FFE916', fontSize: '13px', color:"#434F69", boxShadow:"none", fontFamily: 'gilroy-regular'}}
            startIcon={<AddIcon />}
            onClick={this.onAddStoryboard}
            >
                Add New
            </Button>
          </div>
          {
            <Storyboards
              storyboards={storyboards}
              providerId={this.props.providerId}
              onSaveStoryboardFunc={this.props.onSaveStoryboardFunc}
              onClickStoryboardFunc={this.onClickStoryboard}
              onDeleteStoryboardFunc={this.props.onDeleteStoryboardFunc}
              onCloneStoryboardFunc={this.props.onCloneStoryboardFunc}
            />
          }
        </div>

        <SetStoryboard
          pois={this.props.pois}
          storyboard={this.props.storyboard}
          isModifying={this.state.isModifyingStoryboard}
          onCloseFunc={this.onCloseModal}
          onSaveStoryboardFunc={this.onSaveStoryboard}
          media={this.props.storyboardMedia}
          uploadMediaFunc={this.props.uploadMediaFunc}
          provider = {this.props.provider}
        />
      </div>
    );
  }
}
